/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Directory_Vibebids_Updated_AgoInputs */

const en_directory_vibebids_updated_ago = /** @type {(inputs: Directory_Vibebids_Updated_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated ${i?.time}`)
};

const zh_directory_vibebids_updated_ago = /** @type {(inputs: Directory_Vibebids_Updated_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time}更新`)
};

/**
* | output |
* | --- |
* | "Updated {time}" |
*
* @param {Directory_Vibebids_Updated_AgoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_updated_ago = /** @type {((inputs: Directory_Vibebids_Updated_AgoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Updated_AgoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_updated_ago(inputs)
	return zh_directory_vibebids_updated_ago(inputs)
});
export { directory_vibebids_updated_ago as "directory.vibebids.updated_ago" }